import React, { useContext, useEffect, useState } from "react";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import Heading from "../../Components/Heading/Heading";
import { APICall } from "../../Helpers/API/APICalls";
import {
  ExportToExcelApi,
  ExportToExcelTask,
  GetDropDownList,
  getManagerDashboardData,
  getTaskDashboardGridData,
  FileDownloadTask, //added by kausher
  //Added by yogesh
  getTicketDashboardGridData,
  ExportToExcelTicket,
  FileDownloadTicket,
} from "../../Helpers/API/APIEndPoints";
import { getContext, LoaderContext } from "../../Helpers/Context/Context";
import { useLocation, useNavigate } from "react-router-dom";
import SelectForm from "../../Components/SelectForm/SelectForm";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField } from "@mui/material";
import moment from "moment";
import axios from "axios";
import notify from "../../Helpers/ToastNotification";
// Import to download excel file
import fileDownload from "js-file-download";
import { Overlay, Modal } from "react-bootstrap";
import {
  InputLabel,
  Select,
  SelectChangeEvent,
  MenuItem,
  FormControl,
} from "@mui/material";
import { Button } from "@mui/material";
import TaskAssignment from "../TaskAssignment/TaskAssignment";
import { Tooltip } from "antd";
//import { Modal } from "react-bootstrap";

function ManagerDashboard() {
  const location = useLocation();
  let navigate = useNavigate();
  const [managerDashboardData, setManagerDashboardData] = useState([]);
  const [Engagement, setEngagement] = useState<any>(
    JSON.parse(localStorage.getItem("Engagement") || "[]")
  ); //deepak gupta
  const [EngagementOptions, setEngagementOptions] = useState<any>([]);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [Role, setRole] = useState(null);
  const [fromDate, setFromDate] = React.useState<any>(null);
  const [toDate, setToDate] = React.useState<any>(null);
  const [statusOptions, setStatusOptions] = useState<any>([]);
  const [status, setStatus] = useState<any>(
    JSON.parse(localStorage.getItem("status") || "[]")
  ); //deepak gupta
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const { EmployeeId, RoleId } = getContext();
  const [isTask, setIsTask] = React.useState<any>(location.state);
  const context = getContext();
  const [columns, setColumns] = React.useState<any>([]);
  const [reset, setReset] = React.useState<any>(false);
  const [Employee, setEmployee] = useState<any>(
    JSON.parse(localStorage.getItem("Employee") || "[]")
  ); //deepak gupta
  const [EmployeeOptions, setEmployeeOptions] = useState<any>([]);
  const [costCenterOptions, setcostCenterOptions] = useState<any>([]); //cost center options --Ankita
  const [costCenter, setcostCenter] = useState<any>(
    JSON.parse(localStorage.getItem("costCenter") || "[]")
  ); //deepak gupta
  //Creating state for isActive Filter
  const [isactive, setIsActive] = useState("active"); // isActive Filter -- sangam
  const showCustomToolbar =
    location.state === "true" || location.state === "false"; //sangam
  const [FormErrors, setFormErrors] = useState<any>({}); //prashant
  //kausher
  //const [isOpen, setIsOpen] = useState(false);
  const [downloadData, setDownloadData] = useState([]);

  //Added by yogesh
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenTask, setIsOpenTask] = useState(false);
  const [downloadDataTicket, setDownloadDataTicket] = useState([]);

  //deepak gupta
  useEffect(() => {
    localStorage.setItem("Engagement", JSON.stringify(Engagement));
    localStorage.setItem("status", JSON.stringify(status));
    localStorage.setItem("Employee", JSON.stringify(Employee));
    localStorage.setItem("costCenter", JSON.stringify(costCenter));
  }, [Engagement, status, Employee, costCenter]);

  let formErrorObj = {};
  function handleViewDocument(engagmentObject) { }

  // Added custom color for tooltip
  const customColors = ["#2755f3"];

  const handleFileUrlClick = (url, engagment, taskid, createddate) => {
    setIsOpenTask(true);

    const fileUrls = url.split(",");


    //To get the file name from url    ---Deepak Gupta
    const GetFileNameFromTaskFile = (fileUrl) =>{
      let decodeUrl = decodeURIComponent(fileUrl);

      if(decodeUrl.includes("&file=")){
        return decodeUrl.split("&file=")[1].split("&action=")[0];
      }
      else if(decodeUrl.includes("/Tasks/")){
        return decodeUrl.replace(/.*Tasks/, "").replace(/.*\//,"");
      }
      else{
        return decodeUrl;
      }
    }

    const engagementObjects = fileUrls.map((fileUrl, index) => ({
      engagement: engagment,
      fileUrl: fileUrl,
      taskid: taskid,
      createddate: createddate,
      document: GetFileNameFromTaskFile(fileUrl),
    }));

    setDownloadData(engagementObjects);
  };

  const AttachmentsGridColumns = [
    {
      name: "engagement",
      label: "Engagement",
      options: {
        display: true,
        sort: false,
        filter: false,
      },
    },
    {
      name: "document",
      label: "Attachments",
      options: {
        display: true,
        sort: false,
        filter: false,
      },
    },
    {
      name: "fileUrl",
      label: "FileUrl",
      options: {
        display: false,
        sort: false,
        filter: false,
      },
    },
    {
      name: "taskid",
      label: "TaskId",
      options: {
        display: false,
        sort: false,
        filter: false,
      },
    },
    {
      name: "createddate",
      label: "Created date",
      options: {
        display: false,
        sort: false,
        filter: false,
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        sort: false,
        filter: false,
        display: true,
        customBodyRender: (value, tableMeta) => {
          const engagement = tableMeta.rowData[0];
          const fileUrl = tableMeta.rowData[2];
          const taskid = tableMeta.rowData[3];
          const createddate = tableMeta.rowData[4];
          const handleDownload = () => {
            {
              let reqparam = {
                FileUrl: fileUrl,
                Engagement: engagement,
              };
              axios
                .request({
                  responseType: "blob",
                  method: "POST",
                  url: FileDownloadTask,
                  data: reqparam,
                  headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Headers": "*",
                  },
                })
                .then((response) => {
                  const contentDisposition =
                    response.headers["content-disposition"];

                  //addded by kausher
                  function getFileNameFromUrl(url) {
                    const parsedUrl = new URL(url);

                    let fileName = parsedUrl.pathname.split('/').pop();

                    if (fileName.toLowerCase() === 'doc.aspx') {
                      fileName = parsedUrl.searchParams.get('file');
                    }

                    if (fileName) {
                      fileName = decodeURIComponent(fileName.split('&')[0]);
                    }

                    return fileName || null;
                  }


                  const fileName = getFileNameFromUrl(fileUrl);
                  fileDownload(response.data, fileName);
                })
                .catch((error) => {
                  if (error) {
                    notify(
                      1,
                      "File not found or an error occurred during the download."
                    );
                  }
                });
            }
          };

          return (
            <>
              <Tooltip title="Download" color={customColors[0]}>
                <a className="action_icon" onClick={handleDownload}>
                  <i style={{ "cursor": "pointer" }} className="fa-solid fa-download" aria-hidden="true"></i>
                </a>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];

  // const downloadoptions = {
  //   selectableRows: "none",
  //   count: false,
  //   rowsPerPage: false,
  //   serverSide: false,
  //   rowsPerPageOptions: false,
  //   download: false,
  //   print: false,
  //   viewColumns: false,
  //   filter: false,
  //   search: false,
  //   pagination: false,

  //   setCellHeaderProps: () => ({ align: "center" }),
  // };

  const handleFileUrlClickForTicket = (url, engagment, ticketId, createddate) => {
    setIsOpen(true);

    const fileUrls = url.split(",");

    //To get the file name from url    ---Deepak Gupta
    const GetNameFromFileUrl = (fileUrl) =>{
      
      let decodeUrl = decodeURIComponent(fileUrl);
      if(decodeUrl.includes("&file="))
      {
        return decodeUrl.split("&file=")[1].split("&action=")[0];
      }
      else if(decodeUrl.includes("/Tickets/"))
      {
        return decodeUrl.replace(/.*Tickets/, "").replace(/.*\//,"");
      }else {
        return decodeUrl;
      }
    }

    const engagementObjects = fileUrls.map((fileUrl, index) => ({
      engagement: engagment,
      fileUrl: fileUrl,
      ticketId: ticketId,
      createddate: createddate,
      document: GetNameFromFileUrl(fileUrl)
    }));

    setDownloadDataTicket(engagementObjects);

  };


  const downloadoptions = {
    selectableRows: "none",
    count: false,
    rowsPerPage: false,
    serverSide: false,
    rowsPerPageOptions: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    pagination: false,

    setCellHeaderProps: () => ({ align: "center" }),
  };

  const AttachmentsGridColumnsForTicket = [
    {
      name: "engagement",
      label: "Engagement",
      options: {
        display: true,
      },
    },
    {
      name: "document",
      label: "Attachments",
      options: {
        display: true,
      },
    },
    {
      name: "fileUrl",
      label: "FileUrl",
      options: {
        display: false,
      },
    },
    {
      name: "ticketId",
      label: "TicketId",
      options: {
        display: false,
      },
    },
    {
      name: "createddate",
      label: "Created date",
      options: {
        display: false,
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        sort: false,
        filter: false,
        display: true,
        customBodyRender: (value, tableMeta) => {
          const Engagement = tableMeta.rowData[0];
          const fileUrl = tableMeta.rowData[2];
          const ticketId = tableMeta.rowData[3];
          const createddate = tableMeta.rowData[4];
          const handleDownload = () => {
            {

              let reqparam = {
                FileUrl: fileUrl,
                EngagementString: Engagement,
              };
              axios
                .request({
                  responseType: "blob",
                  method: "POST",
                  url: FileDownloadTicket,
                  data: reqparam,
                  headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Headers": "*",
                  },
                })
                .then((response) => {
                  const contentDisposition =
                    response.headers["content-disposition"];

                  // Extract the filename using a regular expression
                  // const filenameRegex =
                  //   /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                  // const matches =
                  //   filenameRegex.exec(contentDisposition);

                  // let filename = "";
                  // if (matches != null && matches[1]) {
                  //   filename = matches[1].replace(/['"]/g, "");
                  // }


                  //addded by yogesh
                  function getFileNameFromUrl(url) {
                    const parsedUrl = new URL(url);

                    let fileName = parsedUrl.pathname.split('/').pop();

                    if (fileName.toLowerCase() === 'doc.aspx') {
                      fileName = parsedUrl.searchParams.get('file');
                    }

                    if (fileName) {
                      fileName = decodeURIComponent(fileName.split('&')[0]);
                    }

                    return fileName || null;
                  }


                  const fileName = getFileNameFromUrl(fileUrl);
                  fileDownload(response.data, fileName);


                  // Extract the file extension
                  //const fileExtension = filename.substring(filename.lastIndexOf('.'));

                  //addded by yogesh
                  // const getFileExtension = (filename) => {
                  //   return filename
                  //     .slice(
                  //       ((filename.lastIndexOf(".") - 1) >>> 0) +
                  //       2
                  //     )
                  //     .toLowerCase();
                  // };

                  // const fileExtension =
                  //   getFileExtension(filename);


                  // if (filename === "Doc.aspx") {
                  //   // For .docx file download
                  //   const docxFileName = `Ticket_${ticketId}_${moment(
                  //     createddate,
                  //     "DD-MM-YYYY"
                  //   ).format("DD-MMMM-YYYY")}.doc`;
                  //   fileDownload(response.data, docxFileName);
                  // } else if (fileExtension === "pdf") {
                  //   // For .pdf file download
                  //   const pdfFileName = `Ticket_${ticketId}_${moment(
                  //     createddate,
                  //     "DD-MM-YYYY"
                  //   ).format("DD-MMMM-YYYY")}.pdf`;
                  //   fileDownload(response.data, pdfFileName);
                  // } else if (fileExtension === "doc") {
                  //   // For .doc file download
                  //   const docFileName = `Ticket_${ticketId}_${moment(
                  //     createddate,
                  //     "DD-MM-YYYY"
                  //   ).format("DD-MMMM-YYYY")}.doc`;
                  //   fileDownload(response.data, docFileName);
                  // } else if (fileExtension === "png") {
                  //   // For .png file download
                  //   const pngFileName = `Ticket_${ticketId}_${moment(
                  //     createddate,
                  //     "DD-MM-YYYY"
                  //   ).format("DD-MMMM-YYYY")}.png`;
                  //   fileDownload(response.data, pngFileName);
                  // } else if (fileExtension === "jpeg") {
                  //   // For .jpeg or .jpg file download
                  //   const jpegFileName = `Ticket_${ticketId}_${moment(
                  //     createddate,
                  //     "DD-MM-YYYY"
                  //   ).format("DD-MMMM-YYYY")}.jpeg`;
                  //   fileDownload(response.data, jpegFileName);
                  // } else if (fileExtension === "jpg") {
                  //   const jpgFileName = `Ticket_${ticketId}_${moment(
                  //     createddate,
                  //     "DD-MM-YYYY"
                  //   ).format("DD-MMMM-YYYY")}.jpg`;
                  //   fileDownload(response.data, jpgFileName);
                  // } else if (
                  //   fileExtension === "ppt" ||
                  //   fileExtension === "pptx"
                  // ) {
                  //   // For .ppt or .pptx file download
                  //   const pptFileName = `Ticket_${ticketId}_${moment(
                  //     createddate,
                  //     "DD-MM-YYYY"
                  //   ).format("DD-MMMM-YYYY")}.pptx`;
                  //   fileDownload(response.data, pptFileName);
                  // } else if (fileExtension === "xlsx") {
                  //   // For .xlsx file download
                  //   const xlsxFileName = `Ticket_${ticketId}_${moment(
                  //     createddate,
                  //     "DD-MM-YYYY"
                  //   ).format("DD-MMMM-YYYY")}.xlsx`;
                  //   fileDownload(response.data, xlsxFileName);
                  // } else if (fileExtension === "eml") {
                  //   // For .eml file download
                  //   const emlFileName = `Ticket_${ticketId}_${moment(
                  //     createddate,
                  //     "DD-MM-YYYY"
                  //   ).format("DD-MMMM-YYYY")}.eml`;
                  //   fileDownload(response.data, emlFileName);
                  // } else if (fileExtension === "docx") {
                  //   // For .docx file download
                  //   const docxFileName = `Ticket_${ticketId}_${moment(
                  //     createddate,
                  //     "DD-MM-YYYY"
                  //   ).format("DD-MMMM-YYYY")}.docx`;
                  //   fileDownload(response.data, docxFileName);
                  // } else {
                  //   // For unhandled file types, use the extension dynamically
                  //   const defaultFileName = `Ticket_${ticketId}_${moment(
                  //     createddate,
                  //     "DD-MM-YYYY"
                  //   ).format("DD-MMMM-YYYY")}.${fileExtension}`;
                  //   fileDownload(response.data, defaultFileName);
                  // }

                  // fileDownload(response.data, `${data.poNumber}-${moment(data.poDate).format('DD/MMMM/YYYY')}${fileExtension}`);
                  //fileDownload(response.data,`${data.poNumber}-${moment(data.poDate).format('DD/MMMM/YYYY')}.docx`);
                })
                .catch((error) => {
                  if (error) {
                    notify(
                      1,
                      "File not found or an error occurred during the download."
                    );
                  }
                  //console.error(error.response.data);
                });
              //navigate("PurchaseOrderFormEdit", { state: id });
            }

          };

          return (
            <>
              <Tooltip title="Download" color={customColors[0]}>
                <a className="action_icon" onClick={handleDownload}>
                  <i
                    className="fa-solid fa-download"
                    aria-hidden="true"

                  ></i>
                </a>
              </Tooltip>
            </>
          );
        },
      },
    }

  ];

  const gridColumns = [
    {
      name: "taskId",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "engagement",
      label: "Engagement",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "taskTitle",
      label: "Title",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "assignedTo",
      label: "Assigned To",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    // cost center -- Ankita
    // {
    //   name: "costCenterString",
    //   label: "Cost Center",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     sortDescFirst: true,
    //   },
    // }, //costCenter --ankita
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "hoursAssigned",
      label: "Assigned Hrs.",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "hoursSpent",
      label: "Hrs. Spent",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "plannedStartDate",
      label: "Start by Date",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },

    {
      name: "plannedEndDate",
      label: "End By Date",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    // {
    //   name: "action",
    //   label: "Action",
    //   options: {
    //     sort: false,
    //     filter: false,
    //     customBodyRender: (value, tableMeta) => {
    //       const isMember = RoleId.includes("1");
    //       const isEmanager = RoleId.includes("2");
    //       const isManager = RoleId.includes("3");
    //       if (isMember || isEmanager || isManager) {
    //         return (
    //           <div className="editDelete">
    //             <Tooltip title="Edit">
    //               <i
    //                 style={{ marginRight: "0px", cursor: "pointer" }}
    //                 onClick={() => {
    //                   edit(tableMeta);
    //                 }}
    //                 className="fa fa-pencil text-secondary"
    //               ></i>
    //             </Tooltip>
    //           </div>
    //         );
    //       } else {
    //         return (
    //           <i
    //             style={{ marginRight: "0px" }}
    //             className="fa-solid fa-minus"
    //           ></i>
    //         );
    //       }
    //     },
    //   },
    // },
    {
      name: "isActive",
      label: "Active Status",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
        customBodyRender: (value, tableMeta) => {
          const checkActiveRecord =
            tableMeta.tableData[tableMeta.rowIndex].isActive;
          if (checkActiveRecord == false) {
            return (
              <>
                <i className="fa-solid fa-xmark"></i>
              </>
            );
          } else {
            return (
              <>
                <i className="fa-solid fa-check"></i>
              </>
            );
          }
        },
      },
    },
    {
      name: "action",
      label: "Action",
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value, tableMeta) => {
          const editStatus = tableMeta.tableData[tableMeta.rowIndex].status;
          const devTaskTicket =
            tableMeta.tableData[tableMeta.rowIndex].createdBy;

          const data = tableMeta.tableData[tableMeta.rowIndex];
          const planstartdate =
            tableMeta.tableData[tableMeta.rowIndex].plannedStartDate;

          //added by kausher
          let url = data.fileUrl;
          let Engagement = data.engagement;
          //ended by kausher

          const todaysDate = new Date();
          const formateddate = moment(todaysDate).format("DD-MM-YYYY");

          const isActiveTrue = tableMeta.tableData[tableMeta.rowIndex].isActive;

          if (
            editStatus === "Not Started" &&
            devTaskTicket.toString() === EmployeeId && //Omkar P Check here Created by match with this login Employee
            isActiveTrue == true
          ) {
            return (
              <>
                <div
                  className="editDelete"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Tooltip title="Edit" color={customColors[0]}>
                    <a className="action_icon">
                      <i
                        onClick={() => {
                          edit(tableMeta);
                        }}
                        className="fa fa-pencil"
                      ></i>
                    </a>
                  </Tooltip>
                  {/* kausher */}
                  {url && url ? (
                    <>
                      <Tooltip title="Attachments" color={customColors[0]}>
                        <a
                          style={{ marginLeft: "7px", cursor: "pointer" }}
                          onClick={() => handleFileUrlClick(url, Engagement, data.taskId, data.createdDate)}
                        // Pass tempId for deleting
                        >
                          <i className="fa-solid fa-link" aria-hidden="true"></i>
                        </a>
                      </Tooltip>
                    </>
                  ) : null}
                  {/* ended by kausher */}
                </div>
              </>
            );
          } else if (
            editStatus === "In Progress" &&
            planstartdate <= formateddate
          ) {
            return (
              <>
                <Tooltip title="Edit" color={customColors[0]}>
                  <a className="action_icon">
                    <i
                      onClick={() => {
                        edit(tableMeta);
                      }}
                      className="fa fa-pencil"
                    ></i>
                  </a>
                </Tooltip>

                {/* kausher */}
                {url && url ? (
                  <>
                    <Tooltip title="Attachments" color={customColors[0]}>
                      <a
                        style={{ marginLeft: "7px", cursor: "pointer" }}
                        onClick={() => handleFileUrlClick(url, Engagement, data.taskId, data.createdDate)}
                      // Pass tempId for deleting
                      >
                        <i className="fa-solid fa-link" aria-hidden="true"></i>
                      </a>
                    </Tooltip>
                  </>
                ) : null}
                {/* ended by kausher */}

              </>
            );
          }
        },
      },
    },
  ];



  const gridColumnsForTicket = [
    {
      name: "ticketId",
      label: "Id",
      options: {
        display: false,
      },
    },
    // {
    //   name: "id",
    //   label: "Id",
    //   options: {
    //     display: false,
    //   },
    // },
    // {
    //   name: "engagementString",
    //   label: "Engagement",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     sortDescFirst: true,
    //   },
    // },
    {
      name: "engagement",
      label: "Engagement",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },

    {
      name: "ticketTitle",
      label: "Title",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
      },
    },
    // {
    //   name: "assignedToString",
    //   label: "Assigned To",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     sortDescFirst: true,
    //   },
    // },

    {
      name: "assignedTo",
      label: "Assigned To",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },

    // cost center -- Ankita
    // {
    //   name: "costCenterString",
    //   label: "Cost Center",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     sortDescFirst: true,
    //   },
    // }, //costCenter --ankita

    // {
    //   name: "statusString",
    //   label: "Status",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     sortDescFirst: true,
    //   },
    // },

    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "hoursAssigned",
      label: "Assigned Hrs.",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "hoursSpent",
      label: "Hrs. Spent",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },

    {
      name: "startDate",
      label: "Start by Date",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "resolveDate",
      label: "Resolve by Date",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },

    //Omkar P
    {
      name: "isActive",
      label: "Active Status",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
        customBodyRender: (value, tableMeta) => {
          const checkActiveRecord =
            tableMeta.tableData[tableMeta.rowIndex].isActive;
          if (checkActiveRecord == false) {
            return (
              <>
                <i className="fa-solid fa-xmark"></i>
              </>
            );
          } else {
            return (
              <>
                <i className="fa-solid fa-check"></i>
              </>
            );
          }
        },
      },
    },
    {
      name: "action",
      label: "Action",
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value, tableMeta) => {
          // const editStatus = tableMeta.rowData[4];
          const editStatus =
            // tableMeta.tableData[tableMeta.rowIndex].statusString; //changed

            tableMeta.tableData[tableMeta.rowIndex].status; //Added by yogesh
          const devTaskTicket =
            tableMeta.tableData[tableMeta.rowIndex].createdBy;

          const data = tableMeta.tableData[tableMeta.rowIndex];

          const isActiveTrue = tableMeta.tableData[tableMeta.rowIndex].isActive;


          // Added by New yogesh
          let url = data.fileUrl;
          let uniqueUrls = [];

          if (url) {
            let urlArray = url.split(",").map((link) => link.trim());

            uniqueUrls = Array.from(new Set(urlArray));

            uniqueUrls.forEach((url) => {
              if (url) {
                // console.log(url);
              }
            });
          } else {
            console.error("No URLs found in data.fileUrl");
          }

          let EngagementString = data.engagement;
          let engagmentObject = [];
          for (let i = 0; i < uniqueUrls.length; i++) {
            let obj = {
              Engagement: EngagementString,
              FileUrl: uniqueUrls[i],
            };
            engagmentObject.push(obj);
          }

          // console.log(engagmentObject);

          //ended by yogesh
          //Added by yogesh previous change
          // let url = data.fileUrl;
          // let EngagementString = data.engagement;
          // console.log(EngagementString);
          if (
            editStatus === "Not Started" &&
            devTaskTicket.toString() === context.EmployeeId &&
            isActiveTrue === true
          ) {

            return (

              <div
                className="editDelete"
                style={{ display: "flex", alignItems: "center" }}
              >


                {/* Edit Icon with Tooltip */}
                <Tooltip title="Edit">
                  <i
                    style={{ marginRight: "0px", cursor: "pointer" }}
                    onClick={() => {
                      edit(tableMeta);  // Call the edit function with tableMeta data
                    }}
                    className="fa fa-pencil text-secondary"
                  ></i>
                </Tooltip>
                {/*Change by yogesh*/}
                {url && url ? (
                  <>
                    <Tooltip title="Attachments" color={customColors[0]}>
                      <a
                        style={{ marginLeft: "20px", cursor: "pointer", }}
                        onClick={() => handleFileUrlClickForTicket(url, EngagementString, data.ticketId, data.createdDate)}
                      // Pass tempId for deleting
                      >
                        <i className="fa-solid fa-link" aria-hidden="true"></i>
                      </a>
                    </Tooltip>
                  </>
                ) : null}
              </div>
            );

          } else {
            // If editStatus is not "Not Started", you can render something else or nothing.
            return null;
          }
        },
      },
    },
  ];

  //added by yp

  // useEffect(() => {

  //   const fetchData = async () => {
  //     try {
  //       showLoader();
  //       let RoleForData;
  //       const isManager = RoleId.includes("3");
  //       if (isManager) {
  //         RoleForData = 3;
  //       } else {
  //         const isEmanager = RoleId.includes("2");
  //         if (isEmanager) {
  //           RoleForData = 2;
  //         } else {
  //           RoleForData = 1;
  //         }
  //       }

  //       let fDate;
  //       if (fromDate !== null) {
  //         fDate = moment(fromDate).format(moment.HTML5_FMT.DATE);
  //       }
  //       let tDate;
  //       if (toDate !== null) {
  //         tDate = moment(toDate).format(moment.HTML5_FMT.DATE);
  //       }

  //       let costcenter = ArrayIDMapcostcenter(costCenter); // Ankita
  //       let resource = ArrayIDMapEmp(Employee); // Ankita
  //       let statusId = ArrayIDMap(status);

  //       let requestParams = {
  //         Role: RoleForData,
  //         UserId: Number(EmployeeId),
  //         start: start,
  //         pageSize: pageSize,
  //         sortColumn: sortColumn,
  //         sortOrder: sortDirection,
  //         searchText: searchText,
  //         EngagementId: Engagement ? Engagement.map(obj => obj.value).join(', ') : '',
  //         ResourceId: resource.toString(),
  //         CostCenterId: costcenter.toString(),
  //         FromDate: fDate,
  //         ToDate: tDate,
  //         StatusId: statusId.toString(),
  //         activeStatusId: isactive,

  //       };

  //       const data = await APICall(getTicketDashboardGridData, "POST", requestParams);
  //       console.log(data);
  //       // Process the data (dates formatting)

  //       await data?.data?.forEach((ele: any) => {
  //         ele.createdDate = moment(ele.createdDate).format("DD-MM-YYYY");
  //         ele.startDate = moment(ele.startDate).format("DD-MM-YYYY");
  //         ele.resolveDate = moment(ele.resolveDate).format("DD-MM-YYYY");

  //       });
  //       // Update the state with fetched data
  //       await setManagerDashboardData(data?.data);
  //       await setColumns(gridColumnsForTicket);
  //       hideLoader();
  //       await setCount(data?.data[0]?.count);
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };
  //   fetchData();
  // }, []);


  //ended by yp


  //Prashant
  useEffect(() => {

    //deepak gupta
    const clearUnwantedLocalStorage = () => {
      const keysToKeep = ["Engagement", "status", "Employee", "costCenter"];
      Object.keys(localStorage).forEach((key) => {
        if (!keysToKeep.includes(key)) {
          localStorage.removeItem(key);
        }
      });
    };

    clearUnwantedLocalStorage();   //deepak gupta

    (async () => {
      if (location.state === "true") {
        showLoader();
        let RoleForData;
        var isManager = RoleId.includes("3");
        if (isManager) {
          RoleForData = 3;
        } else {
          var isEmanager = RoleId.includes("2");
          if (isEmanager) {
            RoleForData = 2;
          } else {
            RoleForData = 1;
          }
        }
        //added by mahesh on 09-09-2024
        var isManager = RoleId.includes("8");
        if (isManager) {
          RoleForData = 3;
        }
        //end
        var fDate;
        if (fromDate !== null) {
          fDate = moment(fromDate).format(moment.HTML5_FMT.DATE);
        }
        var tDate;
        if (toDate !== null) {
          tDate = moment(toDate).format(moment.HTML5_FMT.DATE);
        }
        let statusId = ArrayIDMap(status);
        let resource = ArrayIDMapEmp(Employee); //-Ankita
        let costcenter = ArrayIDMapcostcenter(costCenter); //-Ankita
        // await OnSubmitValidation();

        let requestParams = {
          Role: RoleForData,
          UserId: Number(EmployeeId),
          start: start,
          pageSize: pageSize,
          sortColumn: sortColumn,
          sortOrder: sortDirection,
          searchText: searchText,
          EngagementId: Engagement
            ? Engagement.map((obj) => obj.value).join(", ")
            : "",
          ResourceId: resource.toString(),
          CostCenterId: costcenter.toString(), //ankita
          FromDate: fDate,
          ToDate: tDate,
          StatusId: statusId.toString(),
          activeStatusId: isactive, //sangam
        };

        const data = await APICall(
          getTaskDashboardGridData,
          "POST",
          requestParams
        );

        await data?.data?.forEach((ele: any) => {
          ele.createdDate = moment(ele.createdDate).format("DD-MM-yyyy");
          ele.plannedEndDate = moment(ele.plannedEndDate).format("DD-MM-yyyy");
          ele.plannedStartDate = moment(ele.plannedStartDate).format(
            "DD-MM-yyyy"
          );
        });

        setManagerDashboardData(data?.data);
        setColumns(gridColumns);

        setCount(data?.data[0]?.count);
        hideLoader();
      }
      else {

        //changes roles yogesh
        let RoleForData;
        var isManager = RoleId.includes("3");
        var isOperationalManager = RoleId.includes("8");
        var isEmanager = RoleId.includes("2");
        if (isManager) {
          RoleForData = 3;
        } else if (isOperationalManager) {
          RoleForData = 8;
        } else if (isEmanager) {
          RoleForData = 2;
        } else {
          RoleForData = 1;
        }
        showLoader();

        var fDate;
        if (fromDate !== null) {
          fDate = moment(fromDate).format(moment.HTML5_FMT.DATE);
        }
        var tDate;
        if (toDate !== null) {
          tDate = moment(toDate).format(moment.HTML5_FMT.DATE);
        }
        let costcenter = ArrayIDMapcostcenter(costCenter); //Ankita
        let resource = ArrayIDMapEmp(Employee); // Ankita
        let statusId = ArrayIDMap(status);

        // let requestParams = {
        //   Role: RoleForData,
        //   UserId: Number(EmployeeId),
        //   Type: "ticket", // location.state === "true" ? "task" : "ticket",
        //   start: start,
        //   pageSize: pageSize,
        //   sortColumn: sortColumn,
        //   sortDirection: sortDirection,
        //   searchText: searchText,
        //   engagement: Engagement ? Engagement : null,
        //   Employees: resource, //ankita
        //   CostCenterId: costcenter, //ankita
        //   fromDate: fDate,
        //   toDate: tDate,
        //   StatusId: statusId,
        //   isExcel: false,
        //   ActiveFilter: isactive, //sangam
        // };

        // const data = await APICall(
        //   getManagerDashboardData,
        //   "POST",
        //   requestParams
        // );

        //await ResetFunction();
        //       await data?.data?.ticketData.forEach((ele: any) => {
        //         ele.createdDate = moment(ele.createdDate).format("DD-MM-YYYY");
        //         ele.startDate = moment(ele.startDate).format("DD-MM-YYYY");
        //         ele.resolveDate = moment(ele.resolveDate).format("DD-MM-YYYY");
        //       });
        //       await setManagerDashboardData(data?.data?.ticketData);
        //       await setColumns(gridColumnsForTicket);

        //       hideLoader();
        //       await setCount(data?.data?.count);
        //     }
        //   })();
        // }, [
        //   start,
        //   sortColumn,
        //   sortDirection,
        //   searchText,
        //   location.state,
        //   reset,
        //   isactive,
        // ]);

        //Added by yogesh
        let requestParams = {
          Role: RoleForData,
          UserId: Number(EmployeeId),
          start: start,
          pageSize: pageSize,
          sortColumn: sortColumn,
          sortOrder: sortDirection,
          searchText: searchText,
          EngagementId: Engagement ? Engagement.map(obj => obj.value).join(', ') : '',
          ResourceId: resource.toString(),
          CostCenterId: costcenter.toString(), //ankita
          FromDate: fDate,
          ToDate: tDate,
          StatusId: statusId.toString(),
          activeStatusId: isactive //sangam
        }

        const data = await APICall(
          getTicketDashboardGridData,
          "POST",
          requestParams
        );
        //console.log(data);
        //add by yogesh
        await data?.data?.forEach((ele: any) => {
          ele.createdDate = moment(ele.createdDate).format("DD-MM-YYYY");
          ele.startDate = moment(ele.startDate).format("DD-MM-YYYY");
          ele.resolveDate = moment(ele.resolveDate).format("DD-MM-YYYY");
        });
        await setManagerDashboardData(data?.data);
        await setColumns(gridColumnsForTicket);
        await showLoader();
        await getTicketDashboardDataForGrid();
        hideLoader();
        await setCount(data?.data[0]?.count);
        //console.log(count);
      }
    })();
  }, [start, sortColumn, sortDirection, searchText, location.state, reset, isactive]);

  //ended by yogesh



  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,

    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },

    customToolbar: showCustomToolbar
      ? () => {
        return (
          <FormControl sx={{ mt: 1 }}>
            <InputLabel id="demo-simple-select-helper-label">
              Active
            </InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              label="Active"
              value={isactive}
              onChange={handleChange}
              sx={{
                width: 80,
                height: 30, // Set the desired height
                "&:focus": { color: "success.main" }, // Change text color to green on focus
              }}
            >
              <MenuItem value={"All"}>All</MenuItem>
              <MenuItem value={"active"}>Yes</MenuItem>
              <MenuItem value={"inactive"}>No</MenuItem>
            </Select>
          </FormControl>
        );
      }
      : null,
  };

  //create edit button to navigate record for edit using usenavigate and pass record id using state.
  //Omkar P

  const edit = (tableMeta) => {
    const id = tableMeta.rowData[0];
    const status = tableMeta.rowData[4];

    const editStatus = tableMeta.tableData[tableMeta.rowIndex].statusString;
    if (location.state === "true") {
      //ResetFunction();
      navigate("TaskAssignment", { state: { id, status } });
    } else {
      //ResetFunction();
      // if (editStatus === "Not Started") {
      // navigate("TicketAssignment", { state: { id } });
      // } else {
      // return null
      // }
      navigate("TicketAssignment", { state: { id } });
    }
  };

  //Omkar P
  const CommonDropdownFunction = async (searchFor, searchValue) => {
    let postObject = {
      searchFor: searchFor,
      searchValue: searchValue,
    };

    const { data } = await APICall(GetDropDownList, "POST", postObject);

    return data;
  };

  useEffect(() => {
    (async () => {
      onLoadAPI();
      await setIsActive("active"); // when page change the isActive filter value set as All  --sangam
    })();
  }, [location, location.state]);

  const ResetFunction = () => {
    setEngagement([]);
    setcostCenter([]); // Ankita
    setEmployee([]); // Ankita
    setFromDate(null);
    setToDate(null);
    setSearchText("");
    setStatus([]);
    localStorage.removeItem("Engagement"); //deepak gupta
    localStorage.removeItem("status"); //deepak gupta
    localStorage.removeItem("Employee"); //deepak gupta
    localStorage.removeItem("costCenter"); //deepak gupta
  };

  useEffect(() => {
    ResetFunction();
  }, [location.state]);

  const onLoadAPI = async () => {
    //Engagement Dropdown
    let RoleForData;
    var isManager = RoleId.includes("3");
    var isOpManager = RoleId.includes("8");
    if (isManager || isOpManager) {
      RoleForData = 2;
    } else {
      var isEmanager = RoleId.includes("2");
      if (isEmanager) {
        RoleForData = 1;
      } else {
        RoleForData = 3;
      }
    }

    let EmployeeId = context.EmployeeId; //hardcoded
    var data;
    if (RoleForData == 1 || RoleForData == 3) {
      if (location.state === "true") {
        data = await CommonDropdownFunction(
          "engagementForEManager",
          EmployeeId
        );
      } else {
        data = await CommonDropdownFunction(
          "engagementForEManagerTicket",
          EmployeeId
        );
      }
    } else {
      if (location.state === "true") {
        //await ResetFunction();
        data = await CommonDropdownFunction("engagementForManager", EmployeeId);
      } else {
        //await ResetFunction();
        data = await CommonDropdownFunction(
          "engagementForManagerTicketForD",
          EmployeeId
        );
      }
    }

    if (data != undefined || data != null) {
      let engagementArray = [];

      await data.map((engagement) => {
        let tempObj;
        tempObj = {
          label: `${engagement.engagement}`,
          value: engagement.id,
        };

        engagementArray.push(tempObj);
      });

      setEngagementOptions(engagementArray);
    }

    (async () => {
      let postObject = {
        searchFor: "employee",
        searchValue: 1,
      };
      const { data } = await APICall(GetDropDownList, "POST", postObject);
      if (data != undefined || data != null) {
        let employeeArray = [];
        await data.map((employee: any) => {
          let tempObj = {
            value: employee.id,
            label: employee.name,
          };
          if (tempObj.value == Employee.value) {
            setEmployee(tempObj);
          }
          employeeArray.push(tempObj);
        });
        setEmployeeOptions(employeeArray);
      }
    })(); // Employee Dropdown--Ankita

    //CostCenter Dropdown--Ankita
    (async () => {
      let postObject = {
        searchFor: "costCenter",
        searchValue: 1,
      };
      const { data } = await APICall(GetDropDownList, "POST", postObject);
      if (data !== null) {
        let arroptions = [];
        data.map((item, index) => {
          arroptions.push({
            value: item.label,
            label: item.label,
            id: item.value,
          });
        });
        arroptions.sort((a, b) => a.label.localeCompare(b.label));
        setcostCenterOptions(arroptions);
      }
    })(); // CostCenter Dropdown--Ankita

    //status dropdown
    (async () => {
      const { data } = await APICall(GetDropDownList, "post", {
        searchFor: "status",
        searchValue: location.state === "true" ? 1 : 2, //1 for task,2 for ticket
      });
      if (data !== null) {
        if (data.length > 0) {
          let statusArr = await data.map((ele) => ({
            value: ele.id,
            label: ele.value,
          }));
          setStatusOptions(statusArr);
        }
      }
    })();
  };

  const handleTextEvent = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "fromDate") {
      let date = event;
      await setFromDate(date);
    }
    if (apiFieldName === "toDate") {
      let date = event;
      await setToDate(date);
      //await getAutoPopulateData();
    }
  };

  const selectOnChange = (event: any, apiFieldName: any) => {
    if (apiFieldName === "Engagement") {
      setEngagement(event);
    }
    if (apiFieldName === "status") {
      setStatus(event);
    }
    if (apiFieldName === "Employees") {
      //For employee Dropdown --Ankita
      setEmployee(event);
    }
    if (apiFieldName === "CostCenter") {
      //For costcenter Dropdown --Ankita
      setcostCenter(event);
    }
  };

  useEffect(() => {
    if (Engagement != null || Engagement != undefined) {
      setEngagement(Engagement);
    }
  }, [Engagement]);

  useEffect(() => {
    if (Employee != null || Employee != undefined) {
      setEmployee(Employee);
    }
  }, [Employee]); // Employee Dropdown--Ankita

  useEffect(() => {
    if (costCenter != null || costCenter != undefined) {
      setcostCenter(costCenter);
    }
  }, [costCenter]); // costcenter Dropdown--Ankita}

  const ArrayIDMapcostcenter = (arr) => {
    let s = [];
    if (arr[0] === null || arr.length < 0) {
      return null;
    }
    arr.map((i) => s.push(i.id));
    return s;
  }; //for cost center --Ankita

  async function getTicketDashboardDataForGrid() {
    if (location.state === `false`) {
      var fDate;
      if (fromDate !== null) {
        fDate = moment(fromDate).format(moment.HTML5_FMT.DATE);
      }
      var tDate;
      if (toDate !== null) {
        tDate = moment(toDate).format(moment.HTML5_FMT.DATE);
      }


      let RoleForData;
      var isManager = RoleId.includes("3");
      var isOperationalManager = RoleId.includes("8");
      var isEmanager = RoleId.includes("2");
      if (isManager) {
        RoleForData = 3;
      } else if (isOperationalManager) {
        RoleForData = 8;
      } else if (isEmanager) {
        RoleForData = 2;
      } else {
        RoleForData = 1;
      }
      showLoader();

      // showLoader();

      let statusId = ArrayIDMap(status);
      let resource = ArrayIDMapEmp(Employee); //-Ankita
      let costcenter = ArrayIDMapcostcenter(costCenter); //-Ankita

      //changed by yogesh


      let requestParams = {
        Role: RoleForData,
        UserId: Number(EmployeeId),
        start: start,
        pageSize: pageSize,
        sortColumn: sortColumn,
        sortOrder: sortDirection,
        searchText: searchText,
        EngagementId: Engagement ? Engagement.map(obj => obj.value).join(', ') : '',
        //EngagementId:637,
        ResourceId: resource.toString(),
        CostCenterId: costcenter.toString(), //ankita
        FromDate: fDate,
        ToDate: tDate,
        StatusId: statusId.toString(),
        activeStatusId: isactive //sangam
      }

      const data = await APICall(
        getTicketDashboardGridData,
        "POST",
        requestParams
      )


      // console.log(data);
      //await ResetFunction();

      //await ResetFunction();
      // await data?.data?.ticketData.forEach((ele: any) => {
      //   ele.createdDate = moment(ele.createdDate).format("DD-MM-YYYY");
      //   ele.startDate = moment(ele.startDate).format("DD-MM-YYYY");
      //   ele.resolveDate = moment(ele.resolveDate).format("DD-MM-YYYY");
      // });
      // setManagerDashboardData(data?.data?.ticketData);
      // setCount(data?.data?.count);
      await data?.data?.forEach((ele: any) => {
        ele.createdDate = moment(ele.createdDate).format("DD-MM-YYYY");
        ele.startDate = moment(ele.startDate).format("DD-MM-YYYY");
        ele.resolveDate = moment(ele.resolveDate).format("DD-MM-YYYY");
      });
      setManagerDashboardData(data?.data);

      setCount(data?.data[0]?.count);
    }

  }
  // useEffect(()=> {
  //   getTicketDashboardDataForGrid();
  // })

  //console.log(managerDashboardData);

  const ArrayIDMapEmp = (arr) => {
    let s = [];
    if (arr[0] === null || arr.length < 0) {
      return null;
    }
    arr.map((i) => s.push(i.value));
    return s;
  }; //for employee/resource --Ankita

  const ArrayIDMap = (arr) => {
    let s = [];
    if (arr[0] === null || arr.length < 0) {
      return null;
    }
    arr.map((i) => s.push(i.value));
    return s;
  };
  //console.log(location.state);

  const onClickFunction = async (action) => {
    if (action === "Submit") {
      if (location.state === "true") {
        showLoader();
        let RoleForData;
        var isManager = RoleId.includes("3");
        if (isManager) {
          RoleForData = 3;
        } else {
          var isEmanager = RoleId.includes("2");
          if (isEmanager) {
            RoleForData = 2;
          } else {
            RoleForData = 1;
          }
        }
        var fDate;
        if (fromDate !== null) {
          fDate = moment(fromDate).format(moment.HTML5_FMT.DATE);
        }
        var tDate;
        if (toDate !== null) {
          tDate = moment(toDate).format(moment.HTML5_FMT.DATE);
        }
        let statusId = ArrayIDMap(status);
        let resource = ArrayIDMapEmp(Employee); //-Ankita
        let costcenter = ArrayIDMapcostcenter(costCenter); //-Ankita
        // await OnSubmitValidation();
        let requestParams = {
          Role: RoleForData,
          UserId: Number(EmployeeId),
          start: start,
          pageSize: pageSize,
          sortColumn: sortColumn,
          sortOrder: sortDirection,
          searchText: searchText,
          EngagementId: Engagement
            ? Engagement.map((obj) => obj.value).join(", ")
            : "",
          ResourceId: resource.toString(),
          CostCenterId: costcenter.toString(), //ankita
          FromDate: fDate,
          ToDate: tDate,
          StatusId: statusId.toString(),
          activeStatusId: isactive, //sangam
        };

        const data = await APICall(
          getTaskDashboardGridData,
          "POST",
          requestParams
        );

        await data.data.forEach((ele: any) => {
          ele.createdDate = moment(ele.createdDate).format("DD-MM-yyyy");
          ele.plannedEndDate = moment(ele.plannedEndDate).format("DD-MM-yyyy");
          ele.plannedStartDate = moment(ele.plannedStartDate).format(
            "DD-MM-yyyy"
          );
        });

        setManagerDashboardData(data.data);
        setColumns(gridColumns);
        setCount(data.data[0].count);
        hideLoader();
      } else {

        var fDate;
        if (fromDate !== null) {
          fDate = moment(fromDate).format(moment.HTML5_FMT.DATE);
        }
        var tDate;
        if (toDate !== null) {
          tDate = moment(toDate).format(moment.HTML5_FMT.DATE);
        }


        let RoleForData;
        var isManager = RoleId.includes("3");
        if (isManager) {
          RoleForData = 3;
        } else {
          var isEmanager = RoleId.includes("2");
          if (isEmanager) {
            RoleForData = 2;
          } else {
            RoleForData = 1;
          }
        }
        showLoader();

        let statusId = ArrayIDMap(status);
        let resource = ArrayIDMapEmp(Employee); //-Ankita
        let costcenter = ArrayIDMapcostcenter(costCenter); //-Ankita

        //changed by yogesh


        let requestParams = {
          Role: RoleForData,
          UserId: Number(EmployeeId),
          start: start,
          pageSize: pageSize,
          sortColumn: sortColumn,
          sortOrder: sortDirection,
          searchText: searchText,
          EngagementId: Engagement ? Engagement.map(obj => obj.value).join(', ') : '',
          //EngagementId:637,
          ResourceId: resource.toString(),
          CostCenterId: costcenter.toString(), //ankita
          FromDate: fDate,
          ToDate: tDate,
          StatusId: statusId.toString(),
          activeStatusId: isactive //sangam
        }

        const data = await APICall(
          getTicketDashboardGridData,
          "POST",
          requestParams
        )


        //console.log(data);
        //await ResetFunction();

        //await ResetFunction();
        // await data?.data?.ticketData.forEach((ele: any) => {
        //   ele.createdDate = moment(ele.createdDate).format("DD-MM-YYYY");
        //   ele.startDate = moment(ele.startDate).format("DD-MM-YYYY");
        //   ele.resolveDate = moment(ele.resolveDate).format("DD-MM-YYYY");
        // });
        // setManagerDashboardData(data?.data?.ticketData);
        // setCount(data?.data?.count);
        await data?.data?.forEach((ele: any) => {
          ele.createdDate = moment(ele.createdDate).format("DD-MM-YYYY");
          ele.startDate = moment(ele.startDate).format("DD-MM-YYYY");
          ele.resolveDate = moment(ele.resolveDate).format("DD-MM-YYYY");
        });
        setManagerDashboardData(data?.data);

        setCount(data?.data[0]?.count);
      }
      hideLoader();
    } else {
      await ResetFunction();

      setReset(!reset);
      hideLoader();
    }
    hideLoader();
  };
  const navigateTo = () => {
    if (location.state === "true") {
      //ResetFunction();
      navigate("TaskAssignment");
    } else {
      //ResetFunction();
      navigate("TicketAssignment");
    }
  };



  const ExportToExcel = async () => {
    showLoader();
    if (location.state === "true") {
      let RoleForData;
      var isManager = RoleId.includes("3");
      if (isManager) {
        RoleForData = 3;
      } else {
        var isEmanager = RoleId.includes("2");
        if (isEmanager) {
          RoleForData = 2;
        } else {
          RoleForData = 1;
        }
      }
      var fDate;
      if (fromDate !== null) {
        fDate = moment(fromDate).format(moment.HTML5_FMT.DATE);
      }
      var tDate;
      if (toDate !== null) {
        tDate = moment(toDate).format(moment.HTML5_FMT.DATE);
      }
      let statusId = ArrayIDMap(status);
      let resource = ArrayIDMapEmp(Employee); //-Ankita
      let costcenter = ArrayIDMapcostcenter(costCenter); //-Ankita
      // await OnSubmitValidation();
      let requestParams = {
        Role: RoleForData,
        UserId: Number(EmployeeId),
        start: start,
        pageSize: count,
        sortColumn: sortColumn,
        sortOrder: sortDirection,
        searchText: searchText,
        EngagementId: Engagement
          ? Engagement.map((obj) => obj.value).join(", ")
          : "",
        ResourceId: resource.toString(),
        CostCenterId: costcenter.toString(), //ankita
        FromDate: fDate,
        ToDate: tDate,
        StatusId: statusId.toString(),
        activeStatusId: isactive, //sangam
      };

      axios
        .request({
          responseType: "blob",
          method: "POST",
          url: ExportToExcelTask,
          data: requestParams,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Access-Control-Allow-Headers": "*",
          },
        })
        .then((response) => {
          fileDownload(
            response.data,
            `${location.state === "true" ? "Task-" : "Ticket-"}` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.xlsx`
          );
          hideLoader();
        })
        .catch((error) => {
          hideLoader();
        });
    } else {
      var fDate;
      if (fromDate !== null) {
        fDate = moment(fromDate).format(moment.HTML5_FMT.DATE);
      }
      var tDate;
      if (toDate !== null) {
        tDate = moment(toDate).format(moment.HTML5_FMT.DATE);
      }
      // let RoleForData;
      // var isManager = RoleId.includes("3");
      // if (isManager) {
      //   RoleForData = 2;
      // } else {
      //   var isEmanager = RoleId.includes("2");
      //   if (isEmanager) {
      //     RoleForData = 1;
      //   } else {
      //     RoleForData = 3;
      //   }
      // }


      //changed by yogesh ticket excel
      let RoleForData;
      var isManager = RoleId.includes("3");
      if (isManager) {
        RoleForData = 3;
      } else {
        var isEmanager = RoleId.includes("2");
        if (isEmanager) {
          RoleForData = 2;
        } else {
          RoleForData = 1;
        }
      }

      // let requestParams = {
      //   Role: RoleForData,
      //   UserId: Number(EmployeeId),
      //   Type: location.state === "true" ? "task" : "ticket",
      //   start: start,
      //   pageSize: pageSize,
      //   sortColumn: sortColumn,
      //   sortDirection: sortDirection,
      //   searchText: searchText,
      //   engagement: Engagement ? Engagement : null,
      //   fromDate: fDate,
      //   toDate: tDate,
      //   status: status && status.value ? status.value : 0,
      //   isExcel: true,
      // };

      let statusId = ArrayIDMap(status);
      let resource = ArrayIDMapEmp(Employee); //for employee/resource --Ankita
      let costcenter = ArrayIDMapcostcenter(costCenter); //-Ankita

      // let requestParams = {
      //   Role: RoleForData,
      //   UserId: Number(EmployeeId),
      //   Type: location.state === "true" ? "task" : "ticket",
      //   start: start,
      //   pageSize: count,
      //   sortColumn: sortColumn,
      //   sortDirection: sortDirection,
      //   searchText: "",
      //   engagement: Engagement ? Engagement : null,
      //   Employees: resource, // Changes --Made changes in ui as well --Ankita
      //   CostCenterId: costcenter, //ankita
      //   fromDate: fDate,
      //   toDate: tDate,
      //   StatusId: statusId,
      //   isExcel: true,
      //   ActiveFilter: isactive, //sangam
      // };


      //changed by yogesh
      let requestParams = {
        Role: RoleForData,
        UserId: Number(EmployeeId),
        start: start,
        pageSize: count,
        sortColumn: sortColumn,
        sortOrder: sortDirection,
        searchText: searchText,
        EngagementId: Engagement ? Engagement.map(obj => obj.value).join(', ') : '',
        ResourceId: resource.toString(),
        CostCenterId: costcenter.toString(), //ankita
        FromDate: fDate,
        ToDate: tDate,
        StatusId: statusId.toString(),
        activeStatusId: isactive //sangam
      }

      axios
        .request({
          responseType: "blob",
          method: "POST",
          url: ExportToExcelTicket,
          data: requestParams,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Access-Control-Allow-Headers": "*",
          },
        })
        .then((response) => {
          fileDownload(
            response.data,
            `${location.state === "true" ? "Task-" : "Ticket-"}` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.xlsx`
          );
          hideLoader();
        })
        .catch((error) => {
          hideLoader();
        });
    }
    hideLoader();
  };

  //function that handle the input value for isActive filter -- sangam
  const handleChange = (event: SelectChangeEvent) => {
    setIsActive(event.target.value);
  };

  const [toggle, setToggle] = useState(false);
  const toggleFilter = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <Heading
        title={location.state == "true" ? "Task Dashboard" : "Ticket Dashboard"}
      />

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              {(RoleId.includes("2") ||
                RoleId.includes("3") ||
                RoleId.includes("8") || //added by mahesh on 09-09-2024
                RoleId.includes("6")) && (
                  <button onClick={() => navigateTo()} className="btn btn-update">
                    Create
                  </button>
                )}
              <div className="d-flex gap-2">
                <button
                  onClick={() => ExportToExcel()}
                  className="btn btn-export"
                >
                  Export to Excel
                </button>
                <a className="filterIcon" onClick={toggleFilter}>
                  <i className="fa fa-filter"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            {toggle && (
              <div className="row mt-3" id="filterContent">
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Engagement </label>
                    <SelectForm
                      options={EngagementOptions}
                      placeholder="Select"
                      isDisabled={false}
                      value={Engagement}
                      onChange={(event) => selectOnChange(event, "Engagement")}
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                      isClearable={true}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Resources </label>
                    <SelectForm
                      options={EmployeeOptions}
                      placeholder="Select"
                      isDisabled={false}
                      value={Employee}
                      onChange={(event) => selectOnChange(event, "Employees")}
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                      isClearable={true}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Vertical</label>
                    <SelectForm
                      options={costCenterOptions}
                      placeholder="Select"
                      isDisabled={false}
                      value={costCenter}
                      onChange={(event) => selectOnChange(event, "CostCenter")}
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                      isClearable={true}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6 ">
                  <div className="form-group d-flex flex-column justify-content-between">
                    <label>From date</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="From date"
                        value={fromDate}
                        onChange={(e) => handleTextEvent(e, "fromDate")}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group d-flex flex-column justify-content-between">
                    <label>To date</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="To date"
                        value={toDate}
                        onChange={(e) => handleTextEvent(e, "toDate")}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Status</label>
                    <SelectForm
                      // options={statusOptions}
                      // placeholder="Select"
                      // isDisabled={false}
                      // value={status}
                      // onChange={(event) => selectOnChange(event, "status")}
                      // isMulti={false}
                      noIndicator={false}
                      noSeparator={false}
                      value={status}
                      onChange={(event) => selectOnChange(event, "status")}
                      options={statusOptions}
                      isMulti={true} //done
                      isSearchable={false}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      placeholder="Select"
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="d-flex gap-2 justify-content-end">
                    <button
                      onClick={() => onClickFunction("reset")}
                      className="btn btn-reset"
                    >
                      Reset
                    </button>
                    <button
                      onClick={() => onClickFunction("Submit")}
                      className="btn btn-submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="col-lg-12 mt-3">
            {isTask === "true" ? (
              <>
                <DynamicGrid
                  options={options}
                  data={managerDashboardData}
                  columns={columns}
                  type={location.state}
                />
              </>
            ) : isTask === "false" ? (
              <>
                <DynamicGrid
                  options={options}
                  data={managerDashboardData}
                  columns={columns}
                  type={location.state}
                />
              </>
            ) : null}

            <Modal
              show={isOpenTask}
              onHide={() => setIsOpenTask(false)}
              backdrop="static"
              keyboard={false}
              centered
              scrollable={true}
              size="lg"
              style={{ zIndex: 1050 }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Attachments</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-lg-12">
                    <DynamicGrid
                      columns={AttachmentsGridColumns}
                      data={downloadData}
                      options={downloadoptions}
                    />
                  </div>
                  <div className="col-lg-12 mt-3">
                    <div className="d-flex justify-content-end gap-2">
                      <button
                        onClick={() => setIsOpenTask(false)}
                        className="btn btn-reset"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            <Modal
              show={isOpen}
              onHide={() => setIsOpen(false)}
              backdrop="static"
              keyboard={false}
              centered
              scrollable={true}
              size="lg"
              style={{ zIndex: 1050 }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Attachments</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-lg-12">
                    <DynamicGrid
                      columns={AttachmentsGridColumnsForTicket}
                      data={downloadDataTicket}
                      options={downloadoptions}
                    />
                  </div>
                  <div className="col-lg-12 mt-3">
                    <div className="d-flex justify-content-end gap-2">
                      <button
                        onClick={() => setIsOpen(false)}
                        className="btn btn-reset"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>

          </div>
        </div>
      </div>
    </>
  );
}

export default ManagerDashboard;